export const balanceAndMovementsInitialDataEndPoint =
  '/Merchant/GetBalanceAndMovementsInitialData';
export const createPayout = '/Merchant/CreatePayout';
